import { ParsedUrlQuery } from 'querystring';

const firstNonEmptyString = (
  value: string | string[] | undefined
): string | undefined => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const parseMediaStartTimeSec = (
  query: ParsedUrlQuery
): number | undefined => {
  const raw = firstNonEmptyString(query.t);
  if (!raw) return undefined;

  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return undefined;

  return parsed;
};

export const parseMediaRecordId = (
  query: ParsedUrlQuery
): number | undefined => {
  const raw = firstNonEmptyString(query.record);
  if (!raw) return undefined;

  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) return undefined;

  return parsed;
};

export const getDeepLinkInitialTimeSec = ({
  videoUrl,
  deepLinkVideoUrl,
  startTimeSec,
}: {
  videoUrl: string;
  deepLinkVideoUrl: string;
  startTimeSec?: number;
}): number | undefined => {
  if (startTimeSec == null || !videoUrl || videoUrl !== deepLinkVideoUrl) {
    return undefined;
  }

  return startTimeSec;
};

export const PRESERVED_MEDIA_QUERY_KEYS = ['t', 'record', 'c', 'mid', 'aid'];

export const withPreservedQuery = (
  path: string,
  query: ParsedUrlQuery,
  keys: string[] = PRESERVED_MEDIA_QUERY_KEYS
): string => {
  const params = new URLSearchParams();

  keys.forEach((key) => {
    const value = firstNonEmptyString(query[key]);
    if (value) params.set(key, value);
  });

  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
};
